require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-tcoopman-bucklescript-tea-starter-kit.json") })
        }
      }, "path---package-unpublished-tcoopman-bucklescript-tea-starter-kit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-tcoopman-bucklescript-tea-starter-kit!./.cache/json/package-unpublished-tcoopman-bucklescript-tea-starter-kit.json
// module id = 968
// module chunks = 231608221292675